import { render } from "./PartnerOrderSummaryReport.vue?vue&type=template&id=1c73aeb0"
import script from "./PartnerOrderSummaryReport.vue?vue&type=script&lang=js"
export * from "./PartnerOrderSummaryReport.vue?vue&type=script&lang=js"
script.render = render

export default script